module.exports = (require("./helpers/browser/import-polyfill")(parcelRequire.resolve("7fR0o"))).then(() => parcelRequire('4Iwoi'));